import React, { FunctionComponent } from "react";
import { IHelpQuestionSection } from "../interfaces";

interface GridQuestionSectionProps {
	hostApi: string;
  shopInfos: any;
	items: IHelpQuestionSection[];
  textButtonSeeThematic: string;
  baseLangUrl: string;
}

interface QuestionSectionItemProps {
	item: IHelpQuestionSection;
	hostApi: string;
	shopRef: string;
  textButtonSeeThematic: string;
  baseLangUrl: string;
}

const QuestionSectionItem: FunctionComponent<QuestionSectionItemProps> = ({item, hostApi, shopRef, textButtonSeeThematic, baseLangUrl}) => {

	return (
		<div className="faq-theme-box" tabIndex={-1}>
      <h3 className="ma0 font18 bold black">{item.label}</h3>
      <img src={hostApi + "/images/faq/" + shopRef + "/" + item.icon} height="60" alt={`Icone de la catégorie '${item.label}'`} />
      <div className="faq-theme-box-hover full-width display-flex flex-column">
        <div className="top-questions">
          <span>{item.label}</span>
          <div className="display-flex flex-column mt05">
						{item.topQuestions.map((question) => (
							<a key={question.id} className="cursor-pointer" href={`/${baseLangUrl}/help/q-${question.slug}/${question.id}`}>{question.question}</a>
						))}
          </div>
        </div>
        <a className="see-more cursor-pointer pt-0" href={`/${baseLangUrl}/help/${item.slug}/${item.id}`}>{textButtonSeeThematic}</a>
      </div>
    </div>
	);
};



const GridQuestionSection: FunctionComponent<GridQuestionSectionProps> = ({hostApi, shopInfos, items, textButtonSeeThematic, baseLangUrl}) => {

  return (
		<section className="faq-theme-section mt-3">
			{items.map(item => (
        <QuestionSectionItem
          key={item.id}
          item={item}
          hostApi={hostApi}
          shopRef={shopInfos.Ref}
          textButtonSeeThematic={textButtonSeeThematic}
          baseLangUrl={baseLangUrl}
        />
      ))}
		</section>
  );
};

export default GridQuestionSection;
